import { createContext, useContext, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';

const ConfirmDialogContext = createContext(null);

export function ConfirmDialogProvider({ children }) {
  const [dialog, setDialog] = useState(null);
  const [erros, setErrors] = useState('');
  const [progress, setProgress] = useState(false);

  const showConfirmDialog = ({
    title,
    message,
    onConfirm,
    confirmText,
    cancelText
  }) => {
    setDialog({ title, message, onConfirm, confirmText, cancelText });
  };

  const handleClose = () => {
    setErrors('')
    setDialog(null)
  };


  const handleConfirm = async () => {
    try {
      setProgress(true)

      await dialog.onConfirm();
      handleClose();
      setProgress(false)

    }
    catch (e) {
      setProgress(false)

      setErrors(e?.response?.data?.message || e?.message || 'Something went wrong. Please try again.')
    } finally {
    }

  };

  return (
    <ConfirmDialogContext.Provider value={{ showConfirmDialog }}>
      {children}

      <Dialog open={Boolean(dialog)} onClose={handleClose}>
        <DialogTitle>{dialog?.title}</DialogTitle>

        <DialogContent>
          <DialogContentText>
            {dialog?.message}
          </DialogContentText>
          {erros && <p style={{ color: 'red' }}>{erros}</p>}
        </DialogContent>

        <DialogActions>
          <Button disabled={progress} onClick={handleClose} color="inherit">
            {dialog?.cancelText || 'Cancel'}
          </Button>

          <Button
            disabled={progress}
            loading={progress}
            onClick={handleConfirm}
            color={dialog?.confirmText === 'Delete' ? 'error' : 'primary'}
            variant="contained"
          >
            {dialog?.confirmText || 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>
    </ConfirmDialogContext.Provider>
  );
}

export const useConfirmDialog = () =>
  useContext(ConfirmDialogContext);
